import { render, staticRenderFns } from "./ReservedBanner.vue?vue&type=template&id=54044d1c&scoped=true"
import script from "./ReservedBanner.vue?vue&type=script&lang=js"
export * from "./ReservedBanner.vue?vue&type=script&lang=js"
import style0 from "./ReservedBanner.vue?vue&type=style&index=0&id=54044d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54044d1c",
  null
  
)

export default component.exports